import { Language } from '../../types/language'

export type NavCopy = {
  links: { name: string; href: string }[]
  cta: string
  toggleMenu: string
  languageLabel: string
}

export const navCopy: Record<Language, NavCopy> = {
  nl: {
    links: [
      {
        name: 'Aanbod',
        href: '#offerings',
      },
      {
        name: 'Reviews',
        href: '#reviews',
      },
      {
        name: 'Over mij',
        href: '#about',
      },
      {
        name: 'Contact',
        href: '#contact',
      },
    ],
    cta: 'Boek een sessie',
    toggleMenu: 'Menu openen of sluiten',
    languageLabel: 'Taal kiezen',
  },
  en: {
    links: [
      {
        name: 'Offerings',
        href: '#offerings',
      },
      {
        name: 'Reviews',
        href: '#reviews',
      },
      {
        name: 'About Me',
        href: '#about',
      },
      {
        name: 'Contact',
        href: '#contact',
      },
    ],
    cta: 'Book a Session',
    toggleMenu: 'Toggle menu',
    languageLabel: 'Select language',
  },
}
